import React, { useEffect, useRef } from 'react'
import { useSuccessMessageState } from 'hooks/ui/useSuccessMessageState'
import { useRouter } from 'next/router'
import { Box } from '@chakra-ui/core'
import { ReactTypeformEmbed } from 'react-typeform-embed';
import useFirebaseSession from 'hooks/useFirebaseSession'

export function JustSignedUpListener() {

    const { showSuccessMessage } = useSuccessMessageState()

    const { query: { justSignedUp } } = useRouter()

    const { loggedInUserEmail } = useFirebaseSession()
    function typeformUrl() {
        return `https://thejuggernaut.typeform.com/to/RwLXbZWV?email=${loggedInUserEmail}`;
    }
    
    const typeformEmbedRef = useRef();

    function openTypeform() {
        const typeformEmbed: any = typeformEmbedRef.current
        typeformEmbed.typeform.open();
      }    

    useEffect(() => {
        if(justSignedUp) {
            showSuccessMessage("You are now subscribed to The Juggernaut.")
            openTypeform(); 
        }
    }, []);

    return (
        <Box position="relative" height="0" width="0">
            <ReactTypeformEmbed
                popup
                autoOpen={false}
                url={typeformUrl()}
                ref={typeformEmbedRef}
            />
        </Box>
    )
}